import { DashboardPage } from '../../components/PremiumDesign';
import { StageAutomationsTab } from '../components/StageAutomationsTab';
import { usePermissions } from '@/common/hooks/usePermissions';
import { PERMISSIONS } from '@/common/config/permissions';
import { AccessDenied } from '@/common/components';

function getCompanyId() {
  try {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userObj = JSON.parse(storedUser);
      return userObj?.company_id || localStorage.getItem('company_id');
    }
  } catch (e) {
    console.error('Failed to parse user object', e);
  }
  return localStorage.getItem('company_id');
}

export function CRMPipelineSettingsPage() {
  const { canAny, role } = usePermissions();
  const isOwner = String(role || '').toLowerCase() === 'owner';
  const canView = isOwner || canAny([PERMISSIONS.CRM_CONFIG.VIEW]);
  const canCreate =
    isOwner ||
    canAny([PERMISSIONS.CRM_CONFIG.CREATE, PERMISSIONS.CRM_CONFIG.MANAGE]);
  const canUpdate =
    isOwner ||
    canAny([PERMISSIONS.CRM_CONFIG.UPDATE, PERMISSIONS.CRM_CONFIG.MANAGE]);
  const canDelete =
    isOwner ||
    canAny([PERMISSIONS.CRM_CONFIG.DELETE, PERMISSIONS.CRM_CONFIG.MANAGE]);

  if (!canView) return <AccessDenied />;

  return (
    <DashboardPage className="pipeline-settings !overflow-hidden !h-full flex-1 min-h-0 flex flex-col">
      <div className="flex flex-col flex-1 min-h-0 bg-transparent">
        <StageAutomationsTab
          companyId={getCompanyId()}
          isReadOnly={!canCreate && !canUpdate}
          canCreate={canCreate}
          canUpdate={canUpdate}
          canDelete={canDelete}
        />
      </div>
    </DashboardPage>
  );
}
